import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'

/* Injected by Vite at build time; falls back to a constant when running outside the bundler. */
declare const __LOCALE_BUILD_ID__: string | undefined
const LOCALE_BUILD_ID =
    typeof __LOCALE_BUILD_ID__ === 'string' ? __LOCALE_BUILD_ID__ : 'dev'

i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        supportedLngs: ['en', 'tr', 'es', 'zh', 'de', 'pt', 'ja'],
        interpolation: { escapeValue: false },
        backend: {
            loadPath: '/locales/{{lng}}/translation.json',
            /* Cache-bust per build — see the __LOCALE_BUILD_ID__ note in vite.config.ts. Without
               this, a browser holding a cached locale file renders new keys as their own names. */
            queryStringParams: { v: LOCALE_BUILD_ID },
        },
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
            lookupLocalStorage: 'language',
        },
        react: {
            bindI18n: 'languageChanged loaded',
            bindI18nStore: 'added removed',
            useSuspense: true,
        },
    })

export default i18n
